import { useMutation } from '@tanstack/react-query'
import type { ReturnsApiCalculateRequest } from '@itsrever/returns-api-types'
import { returnsApi } from '@/redux/api/returnsApiSlice'

const calculate = async (req: ReturnsApiCalculateRequest) => {
    const { data } = await returnsApi.calculate(req)

    return data
}

export const useCalculateSummary = () => {
    return useMutation({
        mutationFn: calculate
    })
}
